var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 189,
    viewBox: "0 0 128 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4170",
    d: "M100.913 0.845496L127.645 0.84549L29.5156 188.902L0.863281 188.902L100.913 0.845496Z",
    fill: "#201F49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardline);
export default __webpack_public_path__ + "static/media/cardline.1c8ee7e161f2a644f344463ddda75032.svg";
export { ForwardRef as ReactComponent };